/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './weather-station-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import weatherStationSettingsTemplate from './weather-station-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.weatherStationSettings', [])
    .directive('agWeatherStationSettings', WeatherStationSettings)
    .name;

/*@ngInject*/
function WeatherStationSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: WeatherStationSettingsController,
        controllerAs: 'vm',
        templateUrl: weatherStationSettingsTemplate
    };
}

/*@ngInject*/
function WeatherStationSettingsController($scope, $rootScope, $translate, types, agTypes, agUtils, assetService,
                                    weatherStationService, userService, attributeService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.weatherStationId = null;
    vm.weatherStation = null;
    vm.allowEditSettings = true;
    vm.show3DSettings = show3DSettings;
    vm.helpPageAction = agUtils.createHelpActionConfig("agWeatherStation", "ag.docsPageSections.weather-station-settings");

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.weatherStationId = null;
            if (vm.ctx.stateController) {
                vm.weatherStationId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadWeatherStation();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newWeatherStationId, prevWeatherStationId) {
                    if (newWeatherStationId && !angular.equals(newWeatherStationId, prevWeatherStationId)) {
                        vm.weatherStationId = newWeatherStationId;
                        loadWeatherStation();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.weatherStation ? (vm.weatherStation.label || vm.weatherStation.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.weather-station.weather-station-settings') + ': ' + title;
        }
    });

    $scope.$on('$destroy', function() {
    });

    $scope.$watch('vm.weatherStation.label', () => {
        if (vm.weatherStation && !$scope.theForm.$invalid) {
            assetService.saveAsset(vm.weatherStation).then(function success() {
                $rootScope.$broadcast('siteAssetUpdated', vm.weatherStation);
            });
        }
    });

    $scope.$watch('vm.weatherStation.coordinate3dX + vm.weatherStation.coordinate3dY + vm.weatherStation.coordinate3dZ + vm.weatherStation.viewrotation', () => {
        if (vm.weatherStation && !$scope.theForm.$invalid) {
            var attributes = [];
            attributes.push({key: 'viewrotation', value: vm.weatherStation.viewrotation});
            attributes.push({key: 'coordinate3dX', value: vm.weatherStation.coordinate3dX});
            attributes.push({key: 'coordinate3dY', value: vm.weatherStation.coordinate3dY});
            attributes.push({key: 'coordinate3dZ', value: vm.weatherStation.coordinate3dZ});
            attributeService.saveEntityAttributes(vm.weatherStation.id.entityType, vm.weatherStation.id.id,
                types.attributesScope.server.value, attributes)
                .then(function success() {});
        }
    });

    function loadWeatherStation() {
        vm.weatherStation = null;
        if (vm.weatherStationId) {
            vm.loading = true;
            weatherStationService.getWeatherStation(vm.weatherStationId).then(
                function success(weatherStation) {
                    vm.weatherStation = weatherStation;
                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function show3DSettings() {
        const siteParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.site);

        if (userService.getAuthority() === 'CUSTOMER_USER') {
            return siteParams?.enable3D ?? false;
        }
        return true;
    }
}
